<template lang="pug">
  div
    p.title Filtros
    div(v-if="!isFiltroProcesso")
      el-row(type='flex')
        el-col(:span="8").container-input.mb
          app-label(label="Município", :required="false")
          el-select.input(
            multiple
            :disabled="isTecnicoMunicipal"
            :multiple-limit='isGrafico? 60 : 0'
            collapse-tags
            filterable
            class="select"
            v-model="filtroPrincipal.listIdMunicipio"
            placeholder="Selecione"
            value-key="id"
          )
            el-option(
              v-for="municipio in municipioList",
              :key="municipio.id",
              :label="municipio.label",
              :value="municipio.id"
          )
        el-col(:span="8").container-input.mb
          app-label(label="Ordem de serviço", :required="false")
          el-select.input(
            multiple
            :multiple-limit='isGrafico? 60 : 0'
            collapse-tags
            filterable
            class="select"
            v-model="filtroPrincipal.listIdOrdemServico"
            placeholder="Selecione"
            value-key="id"
          )
            el-option(
              v-for="os in osList",
              :key="os.id",
              :label="os.numero",
              :value="os.id"
            )
        el-col(:span="8").container-input.mb
          app-label(label="Período de cadastro", :required="false")
          el-date-picker(
            v-model="filtroPrincipal.periodo"
            type="daterange"
            unlink-panels
            range-separator="até"
            start-placeholder="Início"
            end-placeholder="Fim"
            format="dd/MM/yyyy"
            :picker-options="pickerOptions"
          )
      el-row(type='flex')
        el-col(:span="8").container-input.mb
          app-label(label="Cadastrante", :required="false")
          el-select.select(
            multiple
            :multiple-limit='isGrafico? 60 : 0'
            collapse-tags
            filterable
            remote
            v-model="filtroPrincipal.listIdCadastrante"
            :remote-method="getListaCadastrantes"
            value-key="nome"
            placeholder=""
          )
            el-option(
              v-for="cadastrante in cadastranteList",
              :key="cadastrante.id",
              :label="cadastrante.nome",
              :value="cadastrante.id"
          )
        el-col(:span="8").container-input.mb
          app-label(label="Perfil", :required="false")
          el-select.input(
            multiple
            :multiple-limit='2'
            collapse-tags
            filterable
            class="select"
            v-model="filtroPrincipal.listIdPerfilCadastrante"
            placeholder="Selecione"
            value-key="id"
          )
            el-option(
              v-for="perfil in perfilList",
              :key="perfil.id",
              :label="perfil.nome",
              :value="perfil.id"
          )
        el-col(:span="8").container-input.mb
          app-label(label="Endereço", :required="false")
          el-input.input(
            v-model="filtroPrincipal.endereco"
            placeholder=""
          )
      el-row(type='flex')
        el-col(:span="8").container-input.mb
          app-label(label="Bairro", :required="false")
          el-input.input-bairro(
            v-model="filtroPrincipal.bairro"
            placeholder=""
          )
    div(v-else)
      el-row(type='flex')
        el-col(:span="8").container-input.mb
          app-label(label="Município", :required="false")
          el-select.input(
            multiple
            :disabled="isTecnicoMunicipal"
            collapse-tags
            filterable
            class="select"
            v-model="filtroProcesso.listIdMunicipio"
            placeholder="Selecione"
            value-key="id"
          )
            el-option(
              v-for="municipio in municipioList",
              :key="municipio.id",
              :label="municipio.label",
              :value="municipio.id"
          )
        el-col(:span="8").container-input.mb
          app-label(label="Ordem de serviço", :required="false")
          el-select.input(
            collapse-tags
            multiple
            filterable
            class="select"
            v-model="filtroProcesso.listIdOrdemServico"
            placeholder="Selecione"
            value-key="id"
          )
            el-option(
              v-for="os in osList",
              :key="os.id",
              :label="os.numero",
              :value="os.id"
            )
        el-col(:span="8").container-input.mb
          app-label(label="Número do processo", :required="false")
          el-input.input(
            v-model="filtroProcesso.numeroProcesso"
            v-mask="['#########/####']"
          )
      el-row(type='flex')
        el-col(:span="8").container-input.mb
          app-label(label="Cadastrante", :required="false")
          el-select.select(
            multiple
            collapse-tags
            filterable
            remote
            v-model="filtroProcesso.listIdCadastrante"
            :remote-method="getListaCadastrantes"
            value-key="nome"
            placeholder=""
          )
            el-option(
              v-for="cadastrante in cadastranteList",
              :key="cadastrante.id",
              :label="cadastrante.nome",
              :value="cadastrante.id"
          )
        el-col(:span="8").container-input.mb
          app-label(label="Nome do interessado", :required="false")
          el-input.input(
            v-model="filtroProcesso.nomeInteressado"
          )
        el-col(:span="8").container-input
          app-label(label="CPF do interessado", :required="false")
          el-input.input(
            v-model="filtroProcesso.cpfCnpjInteressado",
            v-mask="['###.###.###-##']"
          )
      el-row(type='flex')
        el-col(:span="8").container-input.mb
          app-label(label="Período de cadastro", :required="false")
          el-date-picker(
            v-model="filtroProcesso.periodo"
            type="daterange"
            unlink-panels
            range-separator="até"
            start-placeholder="Início"
            end-placeholder="Fim"
            format="dd/MM/yyyy"
            :picker-options="pickerOptions"
          )
        el-col(:span="8").container-input.mb
          app-label(label="Perfil", :required="false")
          el-select.input(
            multiple
            :multiple-limit='2'
            collapse-tags
            filterable
            class="select"
            v-model="filtroProcesso.listIdPerfilCadastrante"
            placeholder="Selecione"
            value-key="id"
          )
            el-option(
              v-for="perfil in perfilList",
              :key="perfil.id",
              :label="perfil.nome",
              :value="perfil.id"
          )
        el-col(:span="8").container-input.mb
          app-label(label="Endereço", :required="false")
          el-input.input(
            v-model="filtroProcesso.rua"
          )
      el-row(type='flex')
        el-col(:span="8").container-input.mb
          app-label(label="Bairro", :required="false")
          el-input.input(
            v-model="filtroProcesso.bairro"
          )
        el-col(:span="8").container-input.mb
          app-label(label="Lote", :required="false")
          el-input.input(
            v-model="filtroProcesso.lote"
          )
        el-col(:span="8").container-input.mb
          app-label(label="Quadra", :required="false")
          el-input.input(
            v-model="filtroProcesso.quadra"
          )
      el-row(:gutter="10")
        div.row
          span(@click="exibirBuscaPorLote")
            p.busca Pesquisa por lote
          el-tooltip(
            effect='dark',
            placement="top"
          )
            i.el-icon-info.icon-info
            template(slot="content")  Para realizar a pesquisa de mais de um processo, insira a planilha contendo os números dos processos a serem pesquisados de acordo com o modelo a seguir.&nbsp
              a.btn-download(@click="baixarModelo") (Baixar modelo)
        div
          app-upload-area(
            v-if="showPesquisaLote",
            id="lote",
            :target="'publico/upload'"
            :fileType="validExtensions"
            :onSuccess="onSuccess"
            :documento="filtroProcesso.file"
            :hasDownloadButton="false",
            v-model="filtroProcesso.file"
            @removerDocumento="removerDocumento"
          )
    .container-pesquisa
      .button-pesquisa
        el-button(type="text" @click="resetPesquisa(!isFiltroProcesso)")
          | Limpar
        el-button(type="primary" @click="pesquisar(!isFiltroProcesso)")
          i.fal.fa-search
          | &nbsp Pesquisar

</template>

<script>
import AppLabel from '@/components/AppLabel'
import { mapActions } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppUploadArea from '@/components/AppUploadArea'

const UMA_SEMANA = new Date().getTime() - 3600 * 1000 * 24 * 7
const UM_MES = new Date().getTime() - 3600 * 1000 * 24 * 30
const TRES_MESES = new Date().getTime() - 3600 * 1000 * 24 * 90
const HOJE = ''
const UM_ANO = ''

export default {
  mixins: [
    AppNotificacao
  ],
  components: {
    AppLabel,
    AppUploadArea
  },
  props: {
    isFiltroProcesso: {
      type: Boolean,
      required: true
    },
    isGrafico: {
      type: Boolean,
      required: true
    }
  },

  data () {
    return {
      usuario: null,
      isTecnicoMunicipal: false,
      perfisComMunicipioFixo: ['TECNICO_MUNICIPAL_RELATORIO'],
      showPesquisaLote: false,
      validExtensions: ['xlsx', 'xls', 'csv'],
      filtroPrincipal: {
        listIdMunicipio: [],
        listIdOrdemServico: [],
        periodo: [UM_ANO, HOJE],
        periodoInicial: '',
        periodoFinal: '',
        listIdCadastrante: [],
        listIdPerfilCadastrante: [],
        tipoPeriodo: 'MENSAL',
        pagina: 0,
        endereco: '',
        bairro: ''
      },
      filtroProcesso: {
        listIdMunicipio: [],
        listIdOrdemServico: [],
        numeroProcesso: '',
        listIdCadastrante: [],
        listIdPerfilCadastrante: [],
        nomeInteressado: '',
        cpfCnpjInteressado: '',
        periodo: [UM_ANO, HOJE],
        periodoInicial: '',
        periodoFinal: '',
        tipoPeriodo: 'MENSAL',
        lote: '',
        rua: '',
        bairro: '',
        quadra: '',
        file: null,
        nomePlanilha: ''
      },
      municipioList: [],
      osList: [],
      cadastranteList: [],
      perfilList: [],
      pickerOptions: {
        shortcuts: [{
          text: 'Última semana',
          onClick (picker) {
            const end = new Date()
            const start = UMA_SEMANA
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Último mês',
          onClick (picker) {
            const end = new Date()
            const start = UM_MES
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Últimos 3 meses',
          onClick (picker) {
            const end = new Date()
            const start = TRES_MESES
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },

  methods: {
    ...mapActions({
      getUsuario: 'auth/getUsuario',
      getOSReurb: 'relatoriosReurb/getOSReurb',
      getMunicipios: 'relatoriosReurb/getMunicipios',
      getCadastrantesReurb: 'relatoriosReurb/getCadastrantesReurb',
      getPerfis: 'relatoriosReurb/getPerfis',
      getModeloRelatorio: 'dashboardRelatorios/downloadModelo'
    }),
    resetPesquisa (isFiltroPrincipal) {
      this.cadastranteList = []
      this.showPesquisaLote = false
      if (isFiltroPrincipal) {
        this.filtroPrincipal = {
          listIdMunicipio: this.isTecnicoMunicipal ? this.filtroPrincipal.listIdMunicipio : [],
          listIdOrdemServico: [],
          listIdCadastrante: [],
          listIdPerfilCadastrante: [],
          periodo: [UM_ANO, HOJE],
          periodoInicial: '',
          periodoFinal: '',
          tipoPeriodo: 'MENSAL',
          pagina: 0
        }
      } else {
        this.filtroProcesso = {
          listIdMunicipio: this.isTecnicoMunicipal ? this.filtroProcesso.listIdMunicipio : [],
          listIdOrdemServico: [],
          listIdCadastrante: [],
          listIdPerfilCadastrante: [],
          numeroProcesso: '',
          nomeInteressado: '',
          cpfCnpjInteressado: '',
          periodo: [UM_ANO, HOJE],
          periodoInicial: '',
          periodoFinal: '',
          tipoPeriodo: 'MENSAL'
        }
      }
      this.pesquisar()
    },
    pesquisar (isFiltroPrincipal) {
      isFiltroPrincipal
        ? this.$emit('search', this.filtroPrincipal)
        : this.$emit('search', this.filtroProcesso)
    },

    getListaCadastrantes (queryString) {
      if (queryString.length > 0) {
        this.displayCadastranteDropdown = true
        this.getCadastrantesReurb(queryString).then((res) => {
          this.cadastranteList = res
        })
      }
    },
    exibirBuscaPorLote () {
      this.showPesquisaLote = !this.showPesquisaLote
    },
    baixarModelo () {
      this.getModeloRelatorio()
    },
    onSuccess (id, resumableFile, fileKey) {
      this.file = {
        fileKey: fileKey,
        nomeOriginal: resumableFile.fileName,
        tamanho: resumableFile.size
      }
      this.filtroProcesso.nomePlanilha = this.file.fileKey
    },

    removerDocumento () {
      this.file = null
    }
  },

  async mounted () {
    this.usuario = await this.getUsuario()
    if (this.perfisComMunicipioFixo.includes(this.usuario.perfilSelecionado.codigo)) {
      this.filtroPrincipal.listIdMunicipio.push(this.usuario.municipioPrefeitura.id)
      this.filtroProcesso.listIdMunicipio.push(this.usuario.municipioPrefeitura.id)
      this.isTecnicoMunicipal = true
    }
    this.getOSReurb().then((os) => {
      this.osList = os
    })

    this.getMunicipios().then((municipios) => {
      this.municipioList = _.orderBy(municipios, ['label'], ['asc']) // eslint-disable-line
    })

    this.getPerfis().then((perfis) => {
      this.perfilList = _.orderBy(perfis, ['nome'], ['asc']) // eslint-disable-line
    })

    this.pesquisar()
  },

  watch: {
    'filtroPrincipal.listIdMunicipio' (newVal) {
      if (newVal.length >= 60 && this.isGrafico) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
          'O limite de dados a serem exibidos no Gráfico são de 60 municípios. Para filtrar mais dados selecione a opção Tabela.')
      }
    },
    'filtroPrincipal.listIdCadastrante' (newVal) {
      if (newVal.length >= 60 && this.isGrafico) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
          'O limite de dados a serem exibidos no Gráfico são de 60 cadastrantes. Para filtrar mais dados selecione a opção Tabela.')
      }
    },
    'filtroPrincipal.listIdOrdemServico' (newVal) {
      if (newVal.length >= 60 && this.isGrafico) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
          'O limite de dados a serem exibidos no Gráfico são de 60 ordens de serviço. Para filtrar mais dados selecione a opção Tabela.')
      }
    },
    'isGrafico' (newVal) {
      if (newVal === true && this.filtroPrincipal.listIdMunicipio.length > 60) {
        this.filtroPrincipal.listIdMunicipio = this.filtroPrincipal.listIdMunicipio.slice(0, 60)
      } else if (newVal === true && this.filtroPrincipal.listIdCadastrante.length > 60) {
        this.filtroPrincipal.listIdCadastrante = this.filtroPrincipal.listIdCadastrante.slice(0, 60)
      } else if (newVal === true && this.filtroPrincipal.listIdOrdemServico.length > 60) {
        this.filtroPrincipal.listIdOrdemServico = this.filtroPrincipal.listIdOrdemServico.slice(0, 60)
      }
    }
  }

}
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";
@import '@/assets/styles/element-variables.scss';

.container {
  display: flex;
  flex-direction: row;
  padding: 5px;
}

.container-input {
  margin-right: 20px;
  margin-top: 0px;
  margin-bottom: 10px;
}

.select {
  width: 100%;
}

.input-bairro {
  width: 96%;
}

.el-date-editor--daterange.el-input__inner {
  width: 100%;
}
.el-date-editor >>> .el-range-separator {
  width: 20%;
}

.el-date-editor >>> .el-picker-panel__body {
  margin-left: 130px;
}

.el-date-editor
  >>> .el-picker-panel__body-wrapper
  >>> .el-picker-panel__sidebar {
  width: 130px;
}

.container-pesquisa {
  padding: 0px 0px 0px 0px;
  display: flex;
  flex-direction: column;
  :first-child {
    margin-right: 0px;
  }
  .button-pesquisa {
    margin-top: 20px;
    align-self: flex-end;
  }
}
.title {
  margin-bottom: 15px !important;
}
.mb {
  margin-bottom: 2%;
}

.btn-download {
  text-decoration: underline;
  cursor: pointer;
  color: #f1f1f1;
}

.icon-info {
  font-size: 25;
  margin: 0 0 10px 5px;
}

.row {
  margin-top: -20px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.busca {
  padding: 0px 0 8px 0px;
  text-align: left;
  color: $--color-primary !important;
  cursor: pointer;
  &:hover {
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/relatorios_reurb/components/Filtro.vue